module.exports = __webpack_public_path__ + "assets/pdf/ContestRegulation.649e1229.pdf";